import { nunito_sans } from '@styles/fonts'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    width: '100%',
    borderRadius: '16px',
    padding: theme.spacing(7, 5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    minHeight: '282px',
    [theme.breakpoints.down('md')]: {
      minHeight: '175px',
    },

    '@media (max-width:1100px)': {
      padding: theme.spacing(6, 3),
    },
    '@media (max-width:345px)': {
      padding: theme.spacing(3, 1.5),
    },
  },
  zenRootContainer: {
    background: 'none',
    border: '1px solid black',
  },
  imgContainer: {
    position: 'relative',
    width: '72px',
    height: '72px',
    marginBottom: theme.spacing(7),
    '@media (max-width:1100px)': {
      width: '66px',
      height: '66px',
    },
    [theme.breakpoints.down('md')]: {
      width: '55px',
      height: '55px',
    },
    '@media (max-width:345px)': {
      width: '40px',
      height: '40px',
    },
  },
  text: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '34px',
    textAlign: 'center',

    textTransform: 'uppercase',
    '@media (max-width:1100px)': {
      fontSize: '18px',
      lineHeight: '30px',
    },

    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '19.1px',
    },
    '@media (max-width:345px)': {
      fontSize: '11px',
      lineHeight: '14.1px',
    },
  },
}))

export default useStyles
